import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import {
  createTask,
  getTaskDetails,
  getTaskList,
  updateAssignTask,
  approveRejectTask,
} from '../services/taskService';
import {
  getEmployeeDrop,
  getIECTaskTypes,
  getRolesForCustomTask,
  getStatusDrop,
  getTasksNameDrops,
} from '../services/dropDownService';
import {
  EmployeeNameType,
  SelectOptionType,
  TaskInitialStateType,
} from '../utils/Types';
import { API_STATUS } from '../utils/Constant';
import { isAPISuccess } from '../utils/Util';

const initialState: TaskInitialStateType = {
  taskListData: {
    result: [],
    pagination: {
      currentPage: 0,
      pageSize: 0,
      totalPages: 0,
      totalItems: 0,
      fromItem: 0,
      toItem: 0,
    },
  },
  apiProgressStatus: '',
  selectedTask: undefined,
  taskNameList: [],
  rolesListForCustomTask: {},
  IECTaskTypes: [],
  employeeList: [],
  taskStatusList: [],
  employeeNameOptions: [],
};
export const creteNewTask = createAsyncThunk(
  'task/createTask',
  async (data: any) => {
    const res = await createTask(data);
    return res.data;
  }
);
export const assignTaskToOther = createAsyncThunk(
  'task/assignTask',
  async (data: any) => {
    const res = await updateAssignTask(data);
    return res.data;
  }
);
export const fetchTaskList = createAsyncThunk(
  'task/fetchTaskList',
  async (data: any) => {
    const res = await getTaskList(data);
    return res.data;
  }
);
export const fetchTaskDetails = createAsyncThunk(
  'task/fetchTaskDetails',
  async (params: any) => {
    const res = await getTaskDetails(params);
    return res.data;
  }
);
export const fetchTaskNames = createAsyncThunk(
  'task/fetchTaskNames',
  async () => {
    const res = await getTasksNameDrops();
    return res.data;
  }
);
export const fetchRolesForCustomTask = createAsyncThunk(
  'task/fetchRolesForCustomTask',
  async () => {
    const res = await getRolesForCustomTask();
    return res.data;
  }
);
export const fetchIECTaskTypes = createAsyncThunk(
  'task/fetchIECTaskTypes',
  async () => {
    const res = await getIECTaskTypes();
    return res.data;
  }
);
export const fetchEmployeeNames = createAsyncThunk(
  'task/fetchEmployeeNames',
  async () => {
    const res = await getEmployeeDrop();
    return res.data;
  }
);
export const fetchStatusDrop = createAsyncThunk(
  'task/fetchStatusDrop',
  async (params: any) => {
    const res = await getStatusDrop(params);
    return res.data;
  }
);
export const approveOrReject = createAsyncThunk(
  'Task/ApproveOrReject',
  async (data: any) => {
    const res = await approveRejectTask(data);
    return res.data;
  }
);
export const taskSlice = createSlice({
  name: 'task',
  initialState,
  reducers: {
    resetSelectedTask: (state) => {
      state.selectedTask = undefined;
    },
  },
  extraReducers(builder) {
    builder
      .addCase(fetchTaskList.fulfilled, (state, action) => {
        state.apiProgressStatus = API_STATUS.SUCCEEDED;
        state.taskListData = action.payload;
      })
      .addCase(fetchTaskList.pending, (state) => {
        state.apiProgressStatus = API_STATUS.LOADING;
      })
      .addCase(fetchTaskList.rejected, (state) => {
        state.apiProgressStatus = API_STATUS.FAILED;
      })
      .addCase(fetchTaskDetails.fulfilled, (state, action) => {
        state.selectedTask = action.payload.result;
      })
      .addCase(fetchTaskNames.fulfilled, (state, action) => {
        state.taskNameList = action.payload.result;
      })
      .addCase(fetchRolesForCustomTask.fulfilled, (state, action) => {
        state.rolesListForCustomTask = action.payload.result;
      })
      .addCase(fetchIECTaskTypes.fulfilled, (state, action) => {
        const array: SelectOptionType[] = [];
        action?.payload?.result?.forEach(
          (element: { id: string; value: string }) => {
            array.push({
              label: element.value,
              value: element.id,
            });
          }
        );
        state.IECTaskTypes = array;
      })
      .addCase(fetchEmployeeNames.fulfilled, (state, action) => {
        const empList = action.payload.result;
        state.employeeList = empList;
        if (isAPISuccess(action.payload)) {
          const uniqueEmployeesMap = new Map();
          if (empList) {
            empList.forEach((item: EmployeeNameType) => {
              uniqueEmployeesMap.set(item.candidateId, item);
            });
          }
          const names: SelectOptionType[] = [];
          uniqueEmployeesMap.forEach((item) => {
            names.push({ label: item.employeeName, value: item.candidateId });
          });
          state.employeeNameOptions = names;
          state.employeeList = Array.from(uniqueEmployeesMap.values());
        }
      })
      .addCase(fetchStatusDrop.fulfilled, (state, action) => {
        state.taskStatusList = action.payload.result;
      });
  },
});

export const taskSelector = (state: { task: TaskInitialStateType }) =>
  state.task;

export const { resetSelectedTask } = taskSlice.actions;
export const taskApiStatus = (state: { task: TaskInitialStateType }) =>
  state.task.apiProgressStatus;
export default taskSlice.reducer;
